export const ID_VERIFICATION_STATUS_STARTED = 'started';
export const ID_VERIFICATION_STATUS_SUCCESS = 'success';
export const ID_VERIFICATION_STATUS_FAILED = 'failed';
export const ID_VERIFICATION_STATUS_EXPIRED = 'expired';

export const ID_VERIFICATION_TYPE_DRIVERS_LICENSE = 'drivers-license';

export const ID_VERIFICATION_FLOW_SELF_TOUR = 'selfTour';
export const ID_VERIFICATION_FLOW_RENTAL_APPLICATION = 'rentalApplication';

export const ID_VERIFICATION_METHOD_VOUCHED = 'vouched';
export const ID_VERIFICATION_METHOD_MANUAL = 'manual';
